// extracted by mini-css-extract-plugin
module.exports = {"featured_brands":"featured-brands_featured_brands__6_zr6","featured_brand_item":"featured-brands_featured_brand_item__cmyar"};